import { useState, useEffect } from "react";
import { Button, DatePicker, Form, FormInstance, Input, Space, Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { UserGroupNewContract } from "../../models/UserGroupContract";
import { Moment } from "moment";

export type NewUserGroupContractFormProps = {
  form: FormInstance;
  userGroupId: number;
  terminateContractId?: number;
  terminateDate?: Moment;
  terminateMembers?: String[];
};
export const NewUserGroupContractForm = ({form, userGroupId, terminateContractId, terminateDate, terminateMembers}: NewUserGroupContractFormProps) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue({
      'terminateContractId': terminateContractId,
      'terminateDate': terminateDate,
      'terminateMembers': terminateMembers,
      'newContractMembers': [''],
    });
    setLoading(false);
  }, [form, userGroupId, terminateContractId]);

  if (loading) {
    return (
      <Spin size="large" tip="Loading" indicator={<LoadingOutlined />} />
    );
  }

  const terminateMembers2 = terminateMembers?.length > 0 ? terminateMembers : null;
  const hasTerminateContract = terminateContractId !== null && terminateContractId !== undefined;

  const content = (
    <Form<UserGroupNewContract>
      form={form}
      style={{display: 'flex', flexDirection: 'column' }}
    >
      <Form.Item noStyle name="accountId">
        <Input type="hidden" />
      </Form.Item>
      <Form.Item noStyle name="userGroupId">
        <Input type="hidden" />
      </Form.Item>
      <Form.Item noStyle name="terminateContractId">
        <Input type="hidden" />
      </Form.Item>

      <section style={{marginBottom: 36}}>
        <Typography.Title level={5}>
          Datum
        </Typography.Title>
        { hasTerminateContract && (
          <Form.Item
            label="Utflytt"
            name="terminateDate"
            rules={[{
              required: true,
              message: 'Ange utflyttsdatum',
            }]}
          >
            <DatePicker
              format="YYYY-MM-DD"
              style={{ width: "100%" }}
              allowClear={false}
            />
          </Form.Item>
        )}
        <Form.Item
          label="Inflytt"
          name="newContractStartDate"
          dependencies={['terminateDate']}
          rules={[
            { required: true, message: 'Ange inflyttsdatum' },
            ({ getFieldValue }) => ({
              validator: (_, value: Moment | undefined): Promise<void> => {
                const terminateDate = getFieldValue('terminateDate') as
                  | Moment
                  | undefined;
                if (!value || !terminateDate) {
                  return Promise.resolve();
                }
                if (value.isAfter(terminateDate, 'day')) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('Inflyttsdatum måste vara tidigast dagen efter utflytt')
                );
              },
            }),
          ]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            allowClear={false}
            disabledDate={(current: Moment): boolean => {
              const terminateDate = form.getFieldValue('terminateDate') as
                | Moment
                | undefined;
              return !!terminateDate && current.isSameOrBefore(terminateDate, 'day');
            }}
          />
        </Form.Item>
      </section>

      { hasTerminateContract && (
      <section style={{marginBottom: 36}}>
        <Typography.Title level={5}>
          Utflyttande
        </Typography.Title>
        <Space direction="vertical" size={4}>
          { terminateMembers2?.map((m, index) => (
            <Typography.Text key={`${index} ${m}`}>
              {m}
            </Typography.Text>
          )) ?? <Typography.Text style={{fontStyle: 'italic'}}>Ingen</Typography.Text>}
        </Space>
      </section>
      )}


      <section>
        <Typography.Title level={5}>
          Inflyttande
        </Typography.Title>
        <Form.List name="newContractMembers">
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }, index) => (
                <div key={key}>
                  <div>Person {index + 1}</div>

                  <Form.Item label="Email" required>
                    <Space size={0}>
                      <Form.Item
                        {...restField}
                        name={name}
                        noStyle
                          rules={[
                            {
                              required: true,
                              whitespace: true,
                              message: 'Ange en epostadress',
                            },
                            {
                              type: 'email',
                              message: 'Ange en giltig epostadress',
                            },
                          ]}
                      >
                        <Input maxLength={32} type="email" placeholder="namn@example.com" />
                      </Form.Item>

                      <Button
                        danger
                        onClick={(): void => remove(name)}
                        disabled={fields.length <= 1}
                      >
                        Ta bort
                      </Button>
                    </Space>
                  </Form.Item>
                </div>
              ))}

              <Button onClick={(): void => add('')}>
                Lägg till person
              </Button>
            </>
          )}
        </Form.List>
      </section>
    </Form>
  );

  return content;
};

